import classNames from 'classnames';
import React from 'react';

import { Icon, IconTypes } from '@eika/icon';

import useFocusElementOnExit from './useFocusElementOnExit';

import './FilterButton.scss';

type BasicButtonProps = React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>;

export interface FilterbuttonProps extends BasicButtonProps {
    icon?: IconTypes;
    className?: string;
    elementToFocusOnExit: HTMLElement | null;
}

const FilterButton: React.FC<FilterbuttonProps> = ({
    className,
    icon = IconTypes.KRYSS_24,
    elementToFocusOnExit,
    children,
    ...rest
}) => {
    useFocusElementOnExit(elementToFocusOnExit);
    const isButton = rest.onClick || rest.type === 'submit';
    return isButton ? (
        <button
            // eslint-disable-next-line react/button-has-type
            type={rest.type ?? 'button'}
            className={classNames('filter-button', className)}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...rest}
        >
            {children}
            {icon && (
                <span className="filter-button__icon-wrapper">
                    <Icon type={icon} />
                </span>
            )}
        </button>
    ) : (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <span className={classNames('filter-button__no-action', className)} {...rest}>
            {children}
        </span>
    );
};

export default FilterButton;
